module.exports = __webpack_public_path__ + "img/Impact characterisation - Ecosystem Services.726dab0a.svg";